import { Nullable } from './utility-types';

export enum TrackerTrackEventName {
  ContinuePlay = 'continuePlay',
  ClickPlay = 'clickPlay',
  FirstPlay = 'firstPlay',
  GoIntoHostedFallback = 'goIntoHostedFallback',
  PauseResume = 'pauseResume',
}

export enum VideoTrackerPlayerTimeProduct {
  Player = 'player',
  Embed = 'embed',
}

export interface VideoPagePlayerOptions {
  // eslint-disable-next-line @typescript-eslint/camelcase
  player_type: VideoTrackerPlayerTimeProduct;
  // eslint-disable-next-line @typescript-eslint/camelcase
  page_token: Nullable<string>;
  // eslint-disable-next-line @typescript-eslint/camelcase
  service_type: Nullable<string>;

  /**
   * 2 characters country code or empty string if not available
   */
  // eslint-disable-next-line @typescript-eslint/camelcase
  country_code: Nullable<string>;

  parent_url?: Nullable<string>;
}

export interface VideoTrackerState {
  isPinged: Record<number, boolean>;
  seeking: boolean;
  startTime: number;
  playtime: number;
  totalPlaytime: number;
  sourceTime: number;

  goneIntoFallback: boolean;
  errorMessage: string;

  bufferStart: number | null;
  bufferDuration: number;
  bufferCount: number;

  stopped?: boolean;
}

export interface VideoTrackerPlayerTime {
  user_id: string | null;
  activity_type: 'player_time';
  params: {
    buffering_duration: number;
    isPlayerError: false;
    vimeo_loaded_time: number;
    source: string;
    original_source: string;
    total_time_play: number;
    hosted_loaded_time: number;
    failOver: boolean;
    isHostedFailover: boolean;
    re_buffering_count: number;
    source_time: number;
    video_id: string;
    isPlayerPause: boolean;
    product: VideoTrackerPlayerTimeProduct;
    total_time: number;
  };
}
